import React, { useContext, useEffect } from 'react';
import { NewUserRequirementsViewContext } from '../contexts/NewUserRequirementsViewContext';
import {
    IDENTIFICATION_MORE_DETAILS_OTHER_COUNTRIES,
    IDENTIFICATION_MORE_DETAILS_SPAIN,
    translations,
} from './constants';
import { ModalComponent } from 'components/modal/modalComponent';
import { formatText } from 'core/i18n';
import './IdentificationMoreDetailsModal.scss';
import IdentificationMoreDetailsModalImages from './IdentificationMoreDetailsModalImages/IdentificationMoreDetailsModalImages';
import { doTagModalCloseByButton, doTagModalCloseByX, doTagModalDisplay } from '../tagging';
import { isCountrySpain } from 'utilities/multiLanguageHelper';

const IdentificationMoreDetailsModal = () => {
    const { isMoreDetailsModalOpen, handleToggleMoreDetailsModal } = useContext(NewUserRequirementsViewContext);
    const isSpain = isCountrySpain();
    const countryDetails = isSpain ? IDENTIFICATION_MORE_DETAILS_SPAIN : IDENTIFICATION_MORE_DETAILS_OTHER_COUNTRIES;

    const handleClickCancel = () => {
        doTagModalCloseByX();
        handleToggleMoreDetailsModal();
    };

    const handleClickConfirm = () => {
        doTagModalCloseByButton();
        handleToggleMoreDetailsModal();
    };

    useEffect(() => {
        isMoreDetailsModalOpen && doTagModalDisplay();
    }, [isMoreDetailsModalOpen]);

    return (
        <ModalComponent
            isOpen={isMoreDetailsModalOpen}
            onCancel={handleClickCancel}
            title={formatText(countryDetails.title)}
            onConfirm={handleClickConfirm}
            confirmText={formatText(translations.CLOSE_BUTTON)}
            className="new-user-requirements_moreDetails modal-xl"
        >
            <div className="details-container">
                {countryDetails.details.map(detail => (
                    <div key={detail.title} className="details">
                        <IdentificationMoreDetailsModalImages images={detail.images} />
                        <h6 className="bolded-text-18">{formatText(detail.title)}</h6>
                        <p>{formatText(detail.description)}</p>
                    </div>
                ))}
            </div>
        </ModalComponent>
    );
};

export default IdentificationMoreDetailsModal;
